import { baseUrl } from "utils/server";

export const URL_API_BASE = baseUrl;
export const URL_API_AUTH = URL_API_BASE + "/auth";
export const URL_API_ACCESS = URL_API_BASE + "/access";
export const URL_API_ADMIN = URL_API_BASE + "/admin";
export const URL_API_ADMINISTRATION = URL_API_BASE + "/api/administration";
export const URL_API_SHOP = URL_API_BASE + "/shop";
export const URL_API_GEO = URL_API_BASE + "/api/geo";
